document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".pdp-section .csp-img");
  console.log("Total images found:", images.length); // Total images selected

  const observerOptions = {
    root: null, // viewport
    rootMargin: "0px",
    threshold: 0.2 // 20% of image visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      console.log("Entry observed:", entry.target); // Log each observed element
      console.log("Is intersecting:", entry.isIntersecting);

      if (entry.isIntersecting) {
        console.log("Adding 'visible' class to:", entry.target);
        entry.target.classList.add("visible");
        observer.unobserve(entry.target); 
        console.log("Stopped observing:", entry.target);
      }
    });
  }, observerOptions);

  images.forEach((img, index) => {
    console.log(`Observing image ${index + 1}:`, img);
    observer.observe(img);
  });
});



// animate.css
  document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.hero-content');
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('animate__animated', 'animate__fadeInDown');
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
  });

